import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Opts a request out of the global error snackbar when its caller owns visible
 * feedback (inline state, a task-specific snackbar, or a retry flow).
 * Interceptors still rethrow the original error for the caller to handle.
 */
export const SUPPRESS_GLOBAL_ERROR_FEEDBACK = new HttpContextToken<boolean>(() => false);

export function suppressGlobalErrorFeedback(): HttpContext {
  return new HttpContext().set(SUPPRESS_GLOBAL_ERROR_FEEDBACK, true);
}
